export default class Department {
  constructor(
    private id: number = null,
    private name: string = ''
  ){} 
}